var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"haierProduct"}},[_c('Header',{on:{"loaded":_vm.changeLoading}}),_vm._v(" "),(_vm.loaded && _vm.loadNum > 0)?_c('router-view',{style:({minHeight:_vm.minHeight+'px'})}):_vm._e(),_vm._v(" "),(_vm.$route.name!='home'&&_vm.isShow)?_c('Footer',{staticClass:"mt20"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc1b8dd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/haierProduct/HaierProduct.vue
// module id = null
// module chunks = 